<template>
  <NuxtLayout>
    <NuxtLoadingIndicator :duration="1500" color="#6073EE" />
    <NuxtPage :page-key="route => route.fullPath" />
  </NuxtLayout>
</template>

<script setup>
const route = useRoute()
const schema = {
  name: 'Elker',
  description: 'Elker is an innovative speak-up and whistleblowing platform, empowering employees to make their voices heard, anonymously and safely.',
  url: 'https://elker.com',
  logo: 'https://cdn.elker.com/elker_logo_651cfb3fa6.png',
  sameAs: [
    'https://www.linkedin.com/company/elkerofficial/?originalSubdomain=au',
    'https://instagram.com/elkerofficial',
    'https://facebook.com/elkerofficial/',
    'https://twitter.com/elkerofficial'
  ]
}

useSchemaOrg([
  defineOrganization({
    name: schema.name,
    logo: schema.logo,
    sameAs: schema.sameAs
  }),
  defineWebSite({
    name: schema.name,
  }),
  defineWebPage(
    {
      name: schema.name,
      description: schema.description,
      url: schema.url,
      image: schema.logo
    }
  )
])

</script>

<style>
body {
  background-color: #f9f8f6;
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  src:url('https://media.elker.com/c961abba-fcf1-4e0f-a634-afabae34926e/Inter-Regular.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  src:url('https://media.elker.com/917b4fd5-25ac-4ffb-8386-1ce8e93b1233/Inter-Medium.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  src:url('https://media.elker.com/11841ce4-207e-4bdc-80ae-b094ac0b8e55/Inter-Bold.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Lora';
  font-style: normal;
  font-weight: 400;
  src:url('https://media.elker.com/4389d544-c751-482a-b68f-f55bd08ba2ef/Lora-Regular.woff2') format("woff2");
}
</style>